import LoadingScreenComponent from "components/generalComponents/loadingScreenComponent/LoadingScreenComponent";
import { AuthenticationContext } from "context/AuthenticationContext";
import isEmpty from "lodash/isEmpty";
import { Navigate, useNavigate } from "react-router";
import { DataFormat } from "utils/format/DataFormat";
import Main from "./Main";

function PrivateRoute({ children, ...rest }) {
  const token = DataFormat.getToken();
  const navigate = useNavigate();
  const { userMenu, userFeature } = AuthenticationContext();

  if (!token) return <Navigate to="/login" />;

  return (
    <>
      {!isEmpty(userMenu) && !isEmpty(userFeature) ? (
        <Main location={window.location} navigate={navigate}>
          {children}
        </Main>
      ) : (
        <LoadingScreenComponent />
      )}
    </>
  );
}

export default PrivateRoute;
